import { Link } from '@delmonicos/shared-design-system-react/src/components/link/link';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { CellContext } from '@tanstack/react-table';
import { generatePath, useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';

export interface ChargePointListIdentityCellProps
  extends CellContext<
    GatewayChargePointModel,
    GatewayChargePointModel['identity']
  > {}

export const ChargePointListIdentityCell = (
  props: ChargePointListIdentityCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { row, getValue } = props;
  const navigate = useNavigate();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Link
      onClick={() =>
        navigate(
          generatePath(APP_PATH.CHARGE_POINT.DETAILS, { id: row.original.id }),
        )
      }
      fullWidth>
      <Text truncate>{getValue()}</Text>
    </Link>
  );
};
